import { cn } from '../lib/cn';

export interface HeatCell { date: string; count: number; }
export interface ActivityHeatmapProps {
  data: HeatCell[];
  columns?: number;     // default 26 (~6 months by week)
  className?: string;
}

const LEVEL_BG = ['bg-muted', 'bg-orange-200', 'bg-orange-300', 'bg-orange-400', 'bg-orange-600'];

function levelFor(count: number, max: number): number {
  if (count <= 0 || max <= 0) return 0;
  const ratio = count / max;
  if (ratio > 0.75) return 4;
  if (ratio > 0.5) return 3;
  if (ratio > 0.25) return 2;
  return 1;
}

export function ActivityHeatmap({ data, columns = 26, className }: ActivityHeatmapProps) {
  const max = data.reduce((m, d) => Math.max(m, d.count), 0);
  return (
    <div
      className={cn('grid gap-[3px]', className)}
      style={{ gridTemplateColumns: `repeat(${columns}, 1fr)` }}
    >
      {data.map((d) => {
        const lvl = levelFor(d.count, max);
        return (
          <div
            key={d.date}
            data-cell
            data-level={lvl}
            title={`${d.date}: ${d.count}`}
            className={cn('aspect-square rounded-[2px]', LEVEL_BG[lvl])}
          />
        );
      })}
    </div>
  );
}
